import _ from "lodash";
import { configDatePick } from "@/services/GlobalServices";
import DashboardConstants from "@/store/constants/dashboardRecords";

export default {
  name: "CustomTimePicker",
  props: {
    data: {
      type: Object,
      default: {}
    },
    attr: {
      type: String,
      default: ""
    },
    arentAttr: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    },
    customWidth: {
      type: String,
      default: "cus-min-w-60px"
    }
  },
  data() {
    return {
      dataTimePickerOptions: configDatePick("LT")
    };
  },
  methods: {
  },
  computed: {
    getStatusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    focus() {
      return _.get(this.data.item, ['isFocus', this.attr].join("."));
    },
    styleCondition() {
      return _.get(this.data.item, ['style', this.attr, "condition"].join("."));
    },
    stylePrevious() {
      return _.get(this.data.item, ['style', this.attr, "previous"].join("."));
    },
    styleLastest() {
      return _.get(this.data.item, ['style', this.attr, "lastest"].join("."));
    },
    dataPrevious() {
      return _.get(this.data.item, ['previousItem', this.attr].join("."));
    },
    dataLastest() {
      return _.get(this.data.item, this.attr);
    },
    nameElement() {
      return this.parentAttr + "-" + this.attr;
    }
  }
};